import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import PageBanner from "@/components/PageBanner";
import { Plane, Clock, Map, ShieldCheck } from "lucide-react";

const features = [
  {
    icon: Plane,
    title: "Airport Coverage",
    description: "2 international airports in Uganda (Entebbe and Kampala) and 12 domestic airports and airstrips"
  },
  {
    icon: Clock,
    title: "24/7 Service",
    description: "Available round-the-clock for all your airport transfer needs with flight monitoring"
  },
  {
    icon: Map,
    title: "Extensive Network",
    description: "100+ km of paved roads connecting major towns and cities in Uganda, Kenya, Tanzania, and Rwanda"
  },
  {
    icon: ShieldCheck,
    title: "Professional Service",
    description: "IATA registered air ticketing team for seamless flight arrangements and transfers"
  }
];

export default function AirportTransport() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Helmet>
        <title>Airport Transport Services | Ecoplace Tours</title>
        <meta
          name="description"
          content="Enjoy seamless airport transfers with our efficient and reliable services available 24/7."
        />
      </Helmet>

      <PageBanner
        title="Airport Transport Services"
        description="Enjoy seamless airport transfers with our efficient and reliable services. Our team is available 24/7 to ensure a smooth arrival and departure experience."
        backgroundImage="/car.png"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              className="bg-white rounded-xl shadow-lg p-6"
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="p-3 bg-primary/10 rounded-lg">
                  <feature.icon className="w-6 h-6 text-primary" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900">
                  {feature.title}
                </h3>
              </div>
              <p className="text-gray-600">{feature.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-12 text-center"
        >
          <p className="text-lg text-black-600 max-w-3xl mx-auto font-bold">
            Our professional drivers and modern fleet ensure comfortable and reliable transfers between airports and your destinations across East Africa.
          </p>
        </motion.div>
      </div>
    </div>
  );
}
